var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogInInformationLightgray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64457 17.8402C7.04248 15.7429 9.42927 14.3612 12.1388 14.3612C14.8483 14.3612 17.2351 15.7429 18.633 17.8402M12.7002 22.051C12.3389 22.1905 11.9386 22.1905 11.5772 22.051C8.75502 20.9445 6.33177 19.0132 4.6234 16.5091C2.91504 14.005 2.00084 11.0442 2 8.01283V3.44261C2 3.02892 2.16434 2.63219 2.45685 2.33967C2.74938 2.04715 3.14611 1.88281 3.5598 1.88281H20.7176C21.1313 1.88281 21.5281 2.04715 21.8205 2.33967C22.113 2.63219 22.2774 3.02892 22.2774 3.44261V7.99723C22.2798 11.0312 21.367 13.9954 19.6584 16.5026C17.9499 19.0099 15.5249 20.9434 12.7002 22.051ZM12.1387 12.0215C14.077 12.0215 15.6483 10.4502 15.6483 8.51197C15.6483 6.5737 14.077 5.00242 12.1387 5.00242C10.2004 5.00242 8.62916 6.5737 8.62916 8.51197C8.62916 10.4502 10.2004 12.0215 12.1387 12.0215Z",
    stroke: "#D5D5D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogInInformationLightgray);
export default __webpack_public_path__ + "static/media/Log-in-information-lightgray.169b0453.svg";
export { ForwardRef as ReactComponent };